// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2PAKe","requiredAsterisk":"Info_requiredAsterisk__2KzP1"};